// extracted by mini-css-extract-plugin
export default {"printerConfigTitle":"PrinterConfigurationSelect_printerConfigTitle__SaNZq"};